import { DynamicObject } from "../models/General";

export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

const defaultOptions = {
    expires: process.env.REACT_APP_DEFAULT_COOKIES_EXPIRED_IN_MINUTES,
    path: "/",
    ...(typeof window !== "undefined"
      ? window.location.hostname.includes("localhost")
        ? { domain: window.location.hostname }
        : {
            domain:
              "." +
              window.location.hostname.split(".").reverse()[1] +
              "." +
              window.location.hostname.split(".").reverse()[0],
          }
      : {}),
  };
  
  const setCookie = (name : string , value : string, options : DynamicObject)  => {
    // Default values for options:
    let { expires = "" , path = "/", domain = "" } = options;
  
    // If expires is a number, convert it to minutes and create a Date object:
    if (typeof expires === "number") {
      const minutes = expires;
      const now = new Date();
      now.setTime(now.getTime() + minutes * 60 * 1000);
      expires = now;
    }
  
    // Construct the cookie string:
    let cookieString = `${name}=${value}`;
  
    if (expires instanceof Date) {
      cookieString += `;expires=${expires.toUTCString()}`;
    }
  
    if (path) {
      cookieString += `;path=${path}`;
    }
  
    if (domain) {
      cookieString += `;domain=${domain}`;
    }
  
    // Set the cookie:
    document.cookie = cookieString;
  }

  export {defaultOptions, setCookie}
